import type { CompositeTick } from './compositeEventLayout';

type Props = {
  ticks: ReadonlyArray<CompositeTick>;
};

/**
 * ### TimelineGuides
 *
 * The vertical second lines behind one timeline row, drawn the same way in
 * the header row and in every group row so the grid lines up top to bottom.
 *
 * @param props Tick positions
 * @returns The rendered guide lines
 */
export default function TimelineGuides({ ticks }: Props) {
  return (
    <>
      {ticks.map((tick, index) => (
        <span
          key={tick.value}
          className="absolute inset-y-0 border-l border-[rgba(153,156,166,0.3)]"
          style={{
            left: `${tick.position}%`,
            transform:
              index === ticks.length - 1 ? 'translateX(-1px)' : undefined,
          }}
          aria-hidden="true"
        />
      ))}
    </>
  );
}
